import styles from '../dashboardCards.module.css';

/** Label / bar / value rows. Bars are `display:block` with a width % (inline spans collapse to 0). */
const HBarList = ({ rows }) => {
    const max = Math.max(...rows.map(r => r.value), 0) || 1;
    return (
        <div className={styles.hbars}>
            {rows.map(row => (
                <div key={row.key} style={{ display: 'contents' }}>
                    <span className="lab">{row.label}</span>
                    <span className="track">
                        <span
                            data-bar
                            style={{
                                display: 'block',
                                height: '100%',
                                borderRadius: '0 4px 4px 0',
                                width: `${(row.value / max) * 100}%`,
                                background: row.color || 'var(--blue-700)'
                            }}
                        />
                    </span>
                    <span className="val">{row.text}</span>
                </div>
            ))}
        </div>
    );
};

export default HBarList;
